export class OwnerDataConsts {

  static PARTY_CODE_TYPE = 'partyTypeCode';

  static LAST_NAME = 'lastName';
  static FIRST_NAME = 'firstName';
  static PESEL = 'pesel';
  static NIP = 'nip';
  static PASSPORT = 'passport';
  static COMPANY_NAME = 'companyName';
  static WORK = 'work';

  static BIRTH_DATE = 'birthDate';

  static EMAIL = 'email';
  static PHONE_NUMBER = 'phoneNumber';

  static DRIVING_LICENSE_ISSUE_YEAR = 'drivingLicenseIssueYear';
  static DRIVING_LICENSE_ISSUE_MONTH = 'drivingLicenseIssueMonth';
  static NO_DRIVING_LICENSE = 'noDrivingLicense';
  static CITY = 'address.city';
  static STREET = 'address.street';
  static FLAT_NUMBER = 'address.flatNumber';
  static COUNTRY_CODE = 'address.countryCode';
  static BUILDING_NUMBER = 'address.buildingNumber';
  static POSTAL_CODE = 'address.postalCode';
  static CO_OWNERS = 'coOwners';
  static MATRIMONIAL_STATUS = 'matrimonialStatus';
  static CHILDREN_UNDER_26 = 'childrenUnder26';
  static OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH = 'oldestYoungChildYearOfBirth';
  static ADDITIONAL_DRIVERS = 'additionalDrivers';
}
